export const fakeGraphData = [
        { date: "2019-03-23", barData: 8, lineData: 2056 },
        { date: "2019-03-24", barData: 4, lineData: 2060 },
        { date: "2019-03-25", barData: 9, lineData: 2069 },
        { date: "2019-03-26", barData: 3, lineData: 2072 },
        { date: "2019-03-27", barData: 4, lineData: 2076 },
        { date: "2019-03-28", barData: 4, lineData: 2080 },
        { date: "2019-03-29", barData: 5, lineData: 2085 },
        { date: "2019-03-30", barData: 5, lineData: 2090 },
        { date: "2019-03-31", barData: 8, lineData: 2098 },
        { date: "2019-04-01", barData: 12, lineData: 2110 },
        { date: "2019-04-02", barData: 5, lineData: 2115 },
        { date: "2019-04-03", barData: 8, lineData: 2123 },
        { date: "2019-04-04", barData: 2, lineData: 2125 },
        { date: "2019-04-05", barData: 5, lineData: 2130 },
        { date: "2019-04-06", barData: 12, lineData: 2142 },
        { date: "2019-04-07", barData: 2, lineData: 2144 },
        { date: "2019-04-08", barData: 15, lineData: 2159 },
        { date: "2019-04-09", barData: 8, lineData: 2167 },
        { date: "2019-04-10", barData: 8, lineData: 2175 },
        { date: "2019-04-11", barData: 5, lineData: 2180 },
        { date: "2019-04-12", barData: 8, lineData: 2188 },
        { date: "2019-04-13", barData: 11, lineData: 2199 },
        { date: "2019-04-14", barData: 12, lineData: 2211 },
        { date: "2019-04-15", barData: 9, lineData: 2220 },
        { date: "2019-04-16", barData: 10, lineData: 2230 },
        { date: "2019-04-17", barData: 6, lineData: 2236 },
        { date: "2019-04-18", barData: 8, lineData: 2244 },
        { date: "2019-04-19", barData: 5, lineData: 2249 },
        { date: "2019-04-20", barData: 11, lineData: 2260 },
        { date: "2019-04-21", barData: 14, lineData: 2274 }
];



// WEBPACK FOOTER //
// ./src/Info/dev/fakeGraphData.js